export default {
  emmitedCountry: 'Costa Rica y Estados Unidos'
}
